<template>
  <client-only>
    <v-row class="pa-2 mt-5" align="center" justify="center">
      <v-col cols="12" sm="7" md="4" lg="3">
        <v-layout column class="form-wrap" xs12>
          <v-form
            ref="formFeedback"
            v-model="valid"
            class="mt-1"
            lazy-validation
            id="feed-back-form "
          >
            <v-layout row>
              <v-flex align-self-center>
                <p class="hdr primary--text mr-2 mb-5">נו, אז מה אתם אומרים?</p>
              </v-flex>
            </v-layout>
            <v-flex xs12>
              <v-layout column class="look">
                <v-flex>
                  <p class="font-weight-black pb-1 text-right mb-0">
                    <span class="primary--text caption">*</span>
                    איך ה-look החדש שלנו?
                  </p>
                </v-flex>
                <v-flex>
                  <v-radio-group
                    v-model="radioGroup"
                    row
                    hide-details
                    class="ma-0 justify-space-between"
                    :rules="radioRules"
                    required
                    color="red"
                  >
                    <v-radio
                      v-for="n in 5"
                      :key="n"
                      :value="n"
                      hide-details
                      :label="`${n}`"
                      class="ma-0"
                      color="red"
                    />
                  </v-radio-group>
                </v-flex>
                <v-flex>
                  <v-layout>
                    <v-flex class="caption text-right">לא אהבתי</v-flex>
                    <v-flex class="caption text-left">וואו איזה יופי!</v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex>
              <v-layout column class="look">
                <v-flex>
                  <p class="font-weight-black pb-1 text-right mb-0">
                    <span class="primary--text caption">*</span>
                    האם האתר החדש קל ונוח לשימוש?
                  </p>
                </v-flex>
                <v-flex>
                  <v-radio-group
                    v-model="radioGroup2"
                    row
                    hide-details
                    class="ma-0"
                    :rules="radioRules"
                    required
                    justify="space-around"
                  >
                    <v-radio
                      v-for="n in 5"
                      :key="n"
                      :value="n"
                      hide-details
                      :label="`${n}`"
                      class="ma-0"
                      color="primary"
                    />
                  </v-radio-group>
                </v-flex>
                <v-flex>
                  <v-layout>
                    <v-flex class="caption text-right">ממש לא</v-flex>
                    <v-flex class="caption text-left">מאוד</v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>

              <v-layout wrap pt-4>
                <v-flex xs12>
                  <p class="font-weight-black pb-1v text-right mb-0">
                    דואר אלקטרוני / טלפון
                  </p>
                  <v-text-field
                    v-model="emailPhoneModel"
                    :value="emailPhoneModel"
                    outlined
                    dense
                    type="email"
                    clearable
                    autocomplete="off"
                    hide-details
                  />
                </v-flex>
              </v-layout>

              <v-layout column pt-4>
                <v-flex>
                  <p class="font-weight-black pb-1 text-right mb-0">
                    אם יש לכם משהו להוסיף , נשמח לשמוע
                  </p>
                </v-flex>
                <v-flex>
                  <v-textarea
                    id="textarea-feed"
                    v-model="textarea"
                    outlined
                    name="textarea"
                    label="הקלד כאן"
                    rows="2"
                    value
                    solo
                    filled
                    :rules="textareaRules"
                    required="false"
                    mt-0
                  />
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex class="text-center">
                  <v-btn
                    color="primary"
                    rounded
                    class="ma-0 pl-6 pr-6"
                    :disabled="!valid"
                    @click="validateFeedBack"
                  >
                    שלח
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-form>
        </v-layout>
        <div class="text-left feedback-dialog-wrapper pointer-underline">
          <v-dialog
            v-model="dialog"
            max-width="400px"
            content-class="feedback-dialog"
            persistent
          >
            <v-card>
              <v-card-text class="pa-0">
                <v-container grid-list-md>
                  <h3 class="display-18">תודה על שיתוף הפעולה 😀</h3>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="primary darken-1"
                  class="closeBtn"
                  text
                  @click.native="closeFeedback"
                >
                  סגור
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </v-col>
    </v-row>
  </client-only>
</template>

<script>
import { radioRules, textareaRules } from '@/lib/rules.js';
import { CONTACT_US_FEEDBACK } from '@/lib/api.js';

export default {
  layout: 'innerPage',
  name: 'feedbackPage',

  data() {
    return {
      dialog: false,
      mode: '',
      timeout: -1,
      radioGroup: 0,
      radioGroup2: 0,
      textarea: '',
      valid: false,
      emailPhoneModel: '',
      feedBackFilled: 0,

      radioRules,
      textareaRules,
    };
  },

  methods: {
    closeFeedback() {
      this.$router.push('/');
    },
    async validateFeedBack() {
      if (this.$refs.formFeedback.validate()) {
        const data = {
          HowIsOurNewLook: this.radioGroup,
          NewSiteUsability: this.radioGroup2,
          UserFeedback: this.textarea,
          CommunicationInformation: this.emailPhoneModel,
        };

        this.$nuxt.$loading.start();
        try {
          await this.$axios
            .post(`${CONTACT_US_FEEDBACK}`, data)

            .then(() => {
              this.$nuxt.$loading.finish();
              this.dialog = true;
              this.$cookies.set('drushim_feedBackFilled', 1, {
                path: '/',
              });
            });
        } catch (e) {
          this.error = e.response.data.message;
        }
      }
    },
  },
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
.form-wrap {
  padding: 0 20px;
}
.v-input--radio-group--row .v-input--radio-group__input {
  justify-content: space-between;
}

.feedback-dialog-wrapper {
  text-align: left;
  transform: translateY(-25px);
  // color: #000;
}

.v-dialog.feedback-dialog {
  z-index: 2400 !important;
  border-radius: 5%;
}

.look {
  margin-top: 10px;
}

.v-label {
  top: 10px !important;
}

#textarea-feed {
  height: 50px;
  border-radius: 100px;
}

.v-label {
  top: 10px !important;
}

#textarea-feed {
  height: 50px;
}
.hdr {
  font-size: 20px;
  text-align: center;
}
@media only screen and (min-width: 600px) {
  .form-wrap {
    padding: 0 5px;
  }
  .hdr {
    font-size: 30px;
  }
}
</style>
